module.exports = __webpack_public_path__ + "basic-bottom.svg?ca2b24a892fb8c696fe93e20c21eb0c3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/basic-bottom.svg
// module id = 80
// module chunks = 0